export interface DropdownOption {
  value: string | number;
  label: string;
}

export default class SortUtil {
  static sortDropdownOptions(options: DropdownOption[]): DropdownOption[] {
    options.sort((a, b) => a.label.localeCompare(b.label));
    return options;
  }
}
